// TableMaterialesSinMovimiento.tsx

import { useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useFetchGetMaterialesSinMovimiento } from "@/shared/actions/erp/reportes/equipos-sin-movimiento.actions";
import { GeneralTable } from "@/shared/components/ui";
import { useTableColumnsMaterialesSinMovimiento } from "../../hooks";
import { useMemo } from "react";
import { MaterialesSinMovimiento } from "../../types/equipos-sin-movimiento.interface";

interface Props {
  fechaDesdeApplied: string;
  fechaHastaApplied: string;
}

export default function TableMaterialesSinMovimiento({ fechaDesdeApplied, fechaHastaApplied }: Props) {

  const {
    pagination,
    setPagination
  } = useTableFilter();

  const {
    pageIndex,
    pageSize
  } = pagination;

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    columns
  } = useTableColumnsMaterialesSinMovimiento();

  const filtersWithDateRange = useMemo(() => {
    return {
      ...filterObject,
      ...(fechaDesdeApplied ? { fecha_desde: fechaDesdeApplied } : {}),
      ...(fechaHastaApplied ? { fecha_hasta: fechaHastaApplied } : {}),
    };
  }, [fechaDesdeApplied, fechaHastaApplied, filterObject]);

  const {
    isLoading,
    data,
    isRefetching
  } = useFetchGetMaterialesSinMovimiento({
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filtersWithDateRange
    }
  });

  const tableData: MaterialesSinMovimiento[] = data?.data ?? [];

  const totalRows = data?.total ?? tableData.length;

  return <>
    <GeneralTable<MaterialesSinMovimiento>
      columns={columns}
      data={tableData}
      isLoading={isLoading}
      isRefetching={isRefetching}
      // search
      enableGlobalFilter={false}
      // filters
      enableManualFiltering={true}
      columnFilters={columnFilters}
      onColumnFiltersChange={setColumnFilters}
      // pagination
      pagination={pagination}
      onPaging={setPagination}
      rowCount={totalRows}
      // actions
      enableColumnActions={false}
      enableEditing={false}
    />

  </>
}